import {
  SET_GROUP_OPTION,
  UPDATE_GROUP_OPTION
} from 'constants/ActionTypes'
import { createAction } from 'redux-actions'

export const setGroupOption = createAction(SET_GROUP_OPTION, payload => payload)

export const updateGroupOption = createAction(UPDATE_GROUP_OPTION, payload => payload)
